import { Component, OnInit, Inject } from '@angular/core';
import { ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ConfirmComponent } from '../../../shared/dialogs/confirm/confirm.component';
import { AuthService } from '../../../services/auth.service';
import { SnackBarIconService } from '../../../shared/snack-bar-icon/snack-bar-icon.service';

import { WaitingListService } from 'src/app/services/waiting-list.service';
import { Waiting } from 'src/app/models/waiting';
import { EmailService } from 'src/app/services/email.service';
import { ConfigService } from 'src/app/services/config.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-waiting-list-dialog',
  templateUrl: './waiting-list-dialog.component.html',
  styleUrls: ['./waiting-list-dialog.component.scss'],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }
  ]
})
export class WaitingListDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher(); // filter table
  public entityForm: FormGroup;   // store User Form
  public isEdit: boolean; // is insert or update
  public spinner: boolean = false;

  constructor(
    private fb: FormBuilder,
    private _waitingListService: WaitingListService,
    private _configService: ConfigService,
    private _emailService: EmailService,
    private _authService: AuthService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: Waiting
  ) { }


  ngOnInit() {
    this._adapter.setLocale('pt');
    this.entityForm = this.createForm()
    this.setFormValues(this.data, this.entityForm)
  }

  update() {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: { title: "Confirme", message: "Esta ação irá enviar um email para" + "<br><br>" + this.entityForm.controls.member_name.value + "<br><br>" + "Informando sobre a liberação da vaga." }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        this.updateConfirmed();
      }
    })
  }

  updateConfirmed() {

    this.spinner = true;
    let _waiting: boolean = true; //this.entityForm.controls.waiting.value
    let _allowed: boolean = this.entityForm.controls.allowed.value

    this._waitingListService.updateWaiting(this.data.id, _waiting, _allowed)
      .then(() => {

        if (_allowed) {

          let usuario = this.entityForm.controls.member_name.value
          let email = this.entityForm.controls.member_email.value
          let produto = this.entityForm.controls.product_name.value

          let email_text: string;
          let url_logo: string;
          let from: string;
          let bcc: string;
          let subject: string;

          this._configService.configs.forEach((config) => {
            switch (config.id) {
              case "U2T5bydSOyLqFTvxCFdg": // Texto Email Para Lista de Espera
                email_text = config.html_text
                break;
              case "iYP6k0t2ZCxWuSqUuNae": // SBCCV Logo
                url_logo = config.plain_text
                break;
              case "5dxYb1EbBxkxoHT73kTH": // conta de email para envio
                from = config.plain_text
                break;
              case "fHam0uDBEcIZszwEUjg2": // conta para cópia de email BCC
                bcc = config.plain_text
                break;
              case "MKfxlHdTmeuXoDMr9CEq": // título email (subject)
                subject = config.plain_text
                break;
            }
          })

          let html: string = email_text
            .replace("{usuario}", usuario)
            .replace("{produto}", produto)
            .replace("{logo}", "<img style='width: 120px;' src='" + url_logo + "'>")


          let email_send: any = {
            'html': html,
            'subject': subject,
            'from': from,
            'to': email,
            'bcc': bcc
          }

          console.log('--------------------------------')
          console.log(JSON.stringify(email_send))
          console.log('--------------------------------')

          this._emailService.sendStandardEmail(email_send)
            .then(() => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success');
            })
            .catch((error) => {
              console.log("error: " + error)
            })


        } else {
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        }

      })
      .catch((error) => {
        console.log("waiting update error: " + JSON.stringify(error))
        let msgError: string = this._waitingListService.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })
      .finally(() => {
        this.spinner = false
      });

  }


  createEntity(data: any): Waiting {
    let entity = new Waiting();
    entity.id = data.id;
    entity.product_id = data.product_id;
    entity.product_name = data.product_name;
    entity.member_id = data.member_id;
    entity.member_name = data.member_name;
    entity.member_email = data.member_email;
    entity.waiting = data.waiting;
    entity.allowed = data.allowed;
    return entity;

  }

  setFormValues(data, form) {

    form.controls.id.setValue(data.id);

    form.controls.product_id.setValue(data.product_id);
    form.controls.product_name.setValue(data.product_name);

    form.controls.member_id.setValue(data.member_id);
    form.controls.member_name.setValue(data.member_name);
    form.controls.member_email.setValue(data.member_email);

    form.controls.waiting.setValue(data.waiting);
    form.controls.allowed.setValue(data.allowed);

  }

  createForm() {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      product_id: new FormControl(''),
      product_name: new FormControl(''),
      member_id: new FormControl(''),
      member_name: new FormControl(''),
      member_email: new FormControl(''),
      waiting: new FormControl(''),
      allowed: new FormControl('')
    });
    return form
  }


}

